import { API_URL, Accept } from "../constants.js";
import { notify } from "react-notify-toast";
export default function getpendingAmount(component) {
  const Authorization = "bearer " + localStorage.getItem("token");
  const rider_id = localStorage.getItem("rider_id");
  fetch(`${API_URL}rest/V1/rider/getPendingLiabilities/${rider_id}/`, {
    method: "GET",
    headers: { "Content-Type": "application/json", Accept, Authorization },
  })
    .then(function (response) {
      if (!response.ok) {
        notify.show("Network Failure", "error");
      }
      return response.json();
    })
    .then(function (data) {
      console.log("pendingAmountRider", data && data[0]);
      if (data && data[0] && data[0].status != "failure") {
        component.props.pendingAmountAction(data && data[0]);
      }
    });
}



// WEBPACK FOOTER //
// ./src/utility/api/getpendingAmount.js